<footer [attr.id]="id"
        [attr.name]="name">
    <ng-content></ng-content>
</footer>